import {
  ISVGAnimationsSettings,
  ISVGColorSettings,
  ISVGVisibilitySettings,
  SVGRowSettings,
  SVGSettingsNestedKey,
} from './svgChart.types'
import svgMethods from './svg.methods'
import svgAnimations from './svg.animations'

const runColorPreview = (svgWrapperEl: HTMLDivElement, row: ISVGColorSettings) => {
  if (!row.color) return

  const svg: SVGSVGElement = svgWrapperEl.querySelector('svg')
  if (!svg) return

  const node: SVGElement = svg.querySelector('#' + row.node_id)
  if (!node) return

  const prevStyles = node.getAttribute('style') || ''
  svgMethods.applyColor(node, row.color)

  const rollback = () => node.setAttribute('style', prevStyles)
  setTimeout(rollback, 1500)

  return rollback
}

const runVisibilityPreview = (svgWrapperEl: HTMLDivElement, row: ISVGVisibilitySettings) => {
  const svg: SVGSVGElement = svgWrapperEl.querySelector('svg')
  if (!svg) return

  const node: SVGElement = svg.querySelector('#' + row.node_id)
  if (!node) return

  const prevStyles = node.getAttribute('style') || ''

  node.setAttribute('style', 'display: none;')
  const rollback = () => node.setAttribute('style', prevStyles)

  setTimeout(rollback, 1500)
  return rollback
}

const runAnimationPreview = (svgWrapperEl: HTMLDivElement, row: ISVGAnimationsSettings) => {
  const svg: SVGSVGElement = svgWrapperEl.querySelector('svg')
  if (!svg) return

  const node: SVGElement = svg.querySelector('#' + row.node_id)
  if (!node) return

  svgAnimations.prepareSVG([row], svg)
  svgAnimations.animate(row, svg, true)

  const rollback = () => svgAnimations.cancelAnimations([row], svg, true)
  setTimeout(rollback, row.duration * 1000)

  return rollback
}

const run = (row: SVGRowSettings, category: SVGSettingsNestedKey, el: HTMLDivElement) => {
  switch (category) {
    case 'color':
      return runColorPreview(el, row as ISVGColorSettings)
    case 'visibility':
      return runVisibilityPreview(el, row as ISVGVisibilitySettings)
    case 'rotations':
    case 'movements':
      return runAnimationPreview(el, row as ISVGAnimationsSettings)
    default:
      return null
  }
}

const svgSettingsPreviewService = { run }
export default svgSettingsPreviewService
